/* assets/variant-smart-filter.js */
/* PDP/Collections: resilient variant selection + price fallback */
(function () {
  const DEBUG = false;
  const log  = (...a)=>DEBUG && console.log('[variant]', ...a);
  const warn = (...a)=>DEBUG && console.warn('[variant]', ...a);

  /** Utils **/
  function moneyFormatCents(cents) {
    try {
      const fmt = (window.theme && theme.moneyFormat) || window.Shopify?.money_format;
      if (window.Shopify?.formatMoney) {
        let out = Shopify.formatMoney(cents, fmt || "${{amount}}");
        if (!/[€£$]|[A-Z]{3}/.test(out)) {
          const code = window.Shopify?.currency?.active || 'USD';
          const sym  = { USD:'$', AUD:'$', CAD:'C$', EUR:'€', GBP:'£', NZD:'NZ$', SGD:'S$', JPY:'¥' }[code] || (code + ' ');
          out = sym + out;
        }
        return out;
      }
    } catch(e){}
    const code = window.Shopify?.currency?.active || 'USD';
    const sym  = { USD:'$', AUD:'$', CAD:'C$', EUR:'€', GBP:'£', NZD:'NZ$', SGD:'S$', JPY:'¥' }[code] || (code + ' ');
    return sym + (cents/100).toFixed(2);
  }

  function readVariantsForForm(form) {
    const s = form.querySelector('script[type="application/json"].VariantsJson');
    if (!s || !s.textContent) return null;
    try { return JSON.parse(s.textContent); } catch(e){ warn('Bad VariantsJson', e); return null; }
  }

  function syncNativeSelect(form, variantId) {
    const sel = form.querySelector('select[name="id"]');
    if (!sel) return;
    const id = String(variantId || '');
    if (sel.value !== id) sel.value = id;
    for (const opt of sel.options) {
      const should = (opt.value === id);
      if (opt.selected !== should) opt.selected = should;
      if (should) opt.setAttribute('selected','selected'); else opt.removeAttribute('selected');
    }
    sel.dispatchEvent(new Event('input',{bubbles:true}));
    sel.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function updatePriceFallback(form, variant) {
    if (!variant) return;

    const hfw = form.closest('[id^="shopify-section-"],[id^="template--"]')?.querySelector('.hfw-price-block')
               || form.querySelector('.hfw-price-block');

    // Legacy (no HFW block)
    if (!hfw) {
      const priceList = form.querySelector('.product-form__info-list .price-list') ||
                        form.querySelector('.price-list');
      if (!priceList) return;
      const html =
        (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? `<span class="price price--highlight"><span class="visually-hidden">Sale price</span>${moneyFormatCents(variant.price)}</span>
             <span class="price price--compare"><span class="visually-hidden">Regular price</span>${moneyFormatCents(variant.compare_at_price)}</span>`
          : `<span class="price"><span class="visually-hidden">Sale price</span>${moneyFormatCents(variant.price)}</span>`;
      priceList.innerHTML = html;
      return;
    }

    // ----- HFW block path -----
    const code    = window.Shopify?.currency?.active || 'USD';
    const symbols = { USD:'$', AUD:'$', CAD:'C$', EUR:'€', GBP:'£', NZD:'NZ$', SGD:'S$', JPY:'¥' };
    const sym     = symbols[code] || (code + ' ');
    const fmtNum  = (c)=> (c/100).toFixed(2);
    const hasCmp  = !!(variant.compare_at_price && variant.compare_at_price > variant.price);

    // Current price number (symbol is separate)
    const nowAmt = hfw.querySelector('[data-hfw-price-amount]');
    if (nowAmt) nowAmt.textContent = fmtNum(variant.price);

    // Ensure all currency placeholders have the symbol and won’t flicker
    hfw.querySelectorAll('[data-hfw-currency]').forEach(el => {
      if (!el.__set) { el.textContent = sym; el.__set = true; }
    });

    // Compare price (support both guest/tier structures)
    (function renderCompare(){
      let cmpWrap = hfw.querySelector('[data-hfw-compare]') || hfw.querySelector('.hfw-price__compare');
      let cmpAmt  = hfw.querySelector('[data-hfw-compare-amount]') || (cmpWrap && cmpWrap.querySelector('[data-hfw-compare-amount]'));
      if (!cmpWrap) return;
      if (!cmpAmt) {
        cmpWrap.innerHTML = `<span class="hfw-currency" data-hfw-currency aria-hidden="true">${sym}</span><span class="hfw-amount" data-hfw-compare-amount></span>`;
        cmpAmt = cmpWrap.querySelector('[data-hfw-compare-amount]');
      }
      if (hasCmp) {
        cmpAmt.textContent = fmtNum(variant.compare_at_price);
        cmpWrap.hidden = false;
      } else {
        cmpWrap.hidden = true;
      }
    })();

    // YOU SAVE — rewrite fully every refresh; double-RAF to beat theme races
    (function renderSave(){
      const saveWrap = hfw.querySelector('[data-hfw-save]');
      if (!saveWrap) return;

      if (!hasCmp) { saveWrap.hidden = true; return; }

      const diff = (variant.compare_at_price - variant.price);
      saveWrap.innerHTML =
        `YOU SAVE <strong class="hfw-save__amount">
           <span class="hfw-currency" data-hfw-currency aria-hidden="true">${sym}</span><span class="hfw-amount" data-hfw-save-amount-number>${fmtNum(diff)}</span>
         </strong>`;

      // run again next frame in case Warehouse re-draws after us
      requestAnimationFrame(() => {
        const num = saveWrap.querySelector('[data-hfw-save-amount-number]');
        if (num) num.textContent = fmtNum(diff);
        const cur = saveWrap.querySelector('[data-hfw-currency]');
        if (cur && !cur.__set) { cur.textContent = sym; cur.__set = true; }
        // and once more (rare double race)
        requestAnimationFrame(() => {
          const num2 = saveWrap.querySelector('[data-hfw-save-amount-number]');
          if (num2) num2.textContent = fmtNum(diff);
        });
      });

      saveWrap.hidden = false;
    })();
  }

  /** Main binder */
  function initForForm(form) {
    if (form.__vfBound) return;
    const variants = readVariantsForForm(form);
    if (!Array.isArray(variants) || !variants.length) { warn('No variants for form', form); return; }

    form.__vfBound = true;

    function labelText(radio) {
      const lab = form.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      const txt = lab?.querySelector?.('.block-swatch__item-text');
      return ((txt ? txt.textContent : lab?.textContent) || radio.value || '').trim();
    }
    function collect(opt) {
      const radios = [...form.querySelectorAll(`input.product-form__single-selector[name="${opt}"]`)];
      return radios.map(r => {
        const wrap = r.closest('.block-swatch, .swatch, .size-swatch, label') || r.parentElement;
        return { el:r, text:labelText(r), wrap };
      });
    }
    function has(groups, i){ return groups[i] && groups[i].length; }
    function sel(groups, i){
      if (!has(groups,i)) return null;
      const c = groups[i].find(x => x.el.checked);
      return c ? c.text : null;
    }
    function matchAvail(filter) {
      return variants.filter(v => {
        if (filter[1] && v.option1 !== filter[1]) return false;
        if (filter[2] && v.option2 !== filter[2]) return false;
        if (filter[3] && v.option3 !== filter[3]) return false;
        return v.available;
      });
    }
    function applyAllowed(groups, i, set) {
      if (!has(groups,i)) return;
      groups[i].forEach(x => {
        const ok = set.has(x.text);
        x.el.disabled = !ok;
        if (x.wrap) {
          x.wrap.classList.toggle('block-swatch--disabled', !ok);
          x.wrap.classList.toggle('is-hidden', !ok);
          x.wrap.style.display = ok ? '' : 'none';
        } else {
          x.el.style.display = ok ? '' : 'none';
        }
      });
    }
    function ensureValid(groups, i) {
      if (!has(groups,i)) return;
      const current = sel(groups,i);
      const valid = groups[i].find(x => !x.el.disabled && !x.wrap?.classList.contains('is-hidden'));
      if (!valid) return;
      const ok = current && groups[i].some(x => x.text===current && !x.el.disabled && !x.wrap?.classList.contains('is-hidden'));
      if (!ok) {
        valid.el.checked = true;
        valid.el.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    function coerceToAvailable(groups) {
      const s1 = sel(groups,1), s2 = sel(groups,2), s3 = sel(groups,3);
      let chosen = variants.find(v =>
        (!has(groups,1) || v.option1===s1) &&
        (!has(groups,2) || v.option2===s2) &&
        (!has(groups,3) || v.option3===s3) &&
        v.available
      );
      if (chosen) return chosen;
      if (has(groups,3) && s1 && s2) { const c3 = matchAvail({1:s1,2:s2}); if (c3[0]) return c3[0]; }
      if (has(groups,2) && s1)      { const c2 = matchAvail({1:s1});     if (c2[0]) return c2[0]; }
      return variants.find(v => v.available) || null;
    }

    // We’ll re-use this in multiple places
    function refresh() {
      const groups = { 1: collect('option1'), 2: collect('option2'), 3: collect('option3') };
      const idInput = form.querySelector('input[name="id"]');
      const atcBtn  = form.querySelector('button[type="submit"], [name="add"]');

      // reset vis
      [2,3].forEach(i => {
        if (!has(groups,i)) return;
        groups[i].forEach(x => {
          x.el.disabled = false;
          x.wrap?.classList.remove('block-swatch--disabled','is-hidden');
        });
      });

      const s1 = sel(groups,1);
      if (has(groups,2) && s1) {
        const allowed2 = new Set(matchAvail({1:s1}).map(v=>v.option2));
        applyAllowed(groups,2,allowed2); ensureValid(groups,2);
      }
      const s2 = sel(groups,2);
      if (has(groups,3) && s1 && s2) {
        const allowed3 = new Set(matchAvail({1:s1,2:s2}).map(v=>v.option3));
        applyAllowed(groups,3,allowed3); ensureValid(groups,3);
      }

      const chosen = coerceToAvailable(groups);

      if (idInput) idInput.value = chosen?.id || '';
      if (atcBtn)  atcBtn.disabled = !chosen;

      syncNativeSelect(form, chosen?.id);
      updatePriceFallback(form, chosen || null);

      form.dispatchEvent(new CustomEvent('variant:change', { bubbles:true, detail:{ form, variant: chosen || null } }));
    }

    // Events for our radios
    form.addEventListener('change', e => {
      const t = e.target;
      if (t?.name && /^option[123]$/.test(t.name)) refresh();
    });

    // Observer A: inside the form
    const moA = new MutationObserver(() => {
      cancelAnimationFrame(form.__vfRaf||0);
      form.__vfRaf = requestAnimationFrame(refresh);
    });
    moA.observe(form, { childList:true, subtree:true });

    // Observer B: the section root (Warehouse re-renders price block outside the form)
    const sectionRoot =
      form.closest('[id^="shopify-section-"],[id^="template--"]') || document.body;

    const moB = new MutationObserver(() => {
      // throttle + double-RAF to always run after theme redraws
      cancelAnimationFrame(sectionRoot.__vfRaf||0);
      sectionRoot.__vfRaf = requestAnimationFrame(() => {
        requestAnimationFrame(refresh);
      });
    });
    moB.observe(sectionRoot, { childList:true, subtree:true });

    refresh();
  }

  function boot() {
    document.querySelectorAll('form[action^="/cart/add"]').forEach(initForForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
